module.exports = __webpack_public_path__ + "img/2.0c2af9ca.jpg";